import { AlertTriangle, CheckCircle2, Clock } from 'lucide-react';
import type { InvoiceSummary } from '@portal-contract';
import { Badge } from '@/lib/macondo';
import { useI18n } from '@/i18n/I18nProvider';

/** Invoice status: an icon AND words, never colour alone (WCAG 1.4.1). */
export function StatusBadge({ invoice }: { invoice: Pick<InvoiceSummary, 'status' | 'daysOverdue' | 'partiallyPaid'> }) {
  const { t } = useI18n();
  const { status } = invoice;
  const partial = invoice.partiallyPaid && status !== 'paid';
  return (
    <span className="inline-flex flex-wrap items-center gap-100">
      {status === 'paid' ? (
        <Badge variant="success">
          <CheckCircle2 size={14} aria-hidden="true" />
          {t('status.paid')}
        </Badge>
      ) : status === 'overdue' ? (
        <Badge variant="critical">
          <AlertTriangle size={14} aria-hidden="true" />
          {t('status.overdue', { days: invoice.daysOverdue })}
        </Badge>
      ) : (
        <Badge variant="info">
          <Clock size={14} aria-hidden="true" />
          {t('status.open')}
        </Badge>
      )}
      {partial && <Badge variant="default1">{t('status.partial')}</Badge>}
    </span>
  );
}
